import { createSlice, createAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

export const getAllProducts = createAction(
  'products/getAllProducts',
  (payload) => ({
    payload
  })
);

// Slices

const productsSlice = createSlice({
  name: 'products',
  initialState: initialStore.products,
  reducers: {
    setProductsData: (state, { payload }) => {
      state.allProducts = payload;
      state.isLoading = true;
    },
    getProductsFail: (state) => {
      state.isLoading = false;
    }
  }
});
export const { setProductsData, getProductsFail } = productsSlice.actions;
export const { reducer } = productsSlice;

// Selectors
export const getProductsSelector = (state: IState) =>
  state && state.products.allProducts;
